import { IAddHistoryModels } from 'src/redux/features/methodModels/addHistoryModels/types';
import { IAddModels } from 'src/redux/features/methodModels/addModels/types';
import { ApiUrlEnum } from '../enum';
import { del, get, post, putData } from './api';

export default {
  loadAllModels: (params: string) => get(`${ApiUrlEnum.ALL_MODELS}${params}`),
  loadEditModels: (id: string, editModels: any) =>
    putData(`${ApiUrlEnum.ALL_MODELS}/${id}`, editModels),
  loadAddModels: (addModels: IAddModels) =>
    post(ApiUrlEnum.ALL_MODELS, addModels),
  loadDeleteModels: (id: string) => del(`${ApiUrlEnum.ALL_MODELS}/${id}`),
  loadOneModels: (id: string) => get(`${ApiUrlEnum.ALL_MODELS}/${id}`),
  loadListHistory: (id: string) =>
    get(`${ApiUrlEnum.ALL_MODELS}/${id}${ApiUrlEnum.HISTORY_INPUTS}`),
  loadAddHistoryModels: (addHistoryModels: IAddHistoryModels, id: string) =>
    post(
      `${ApiUrlEnum.ALL_MODELS}/${id}${ApiUrlEnum.HISTORY_INPUTS}`,
      addHistoryModels,
    ),
  loadRunModels: (id: string) =>
    post(`${ApiUrlEnum.ALL_MODELS}/${id}${ApiUrlEnum.RUN}`),
};
